
import React from "react";

const AIComponent = () => {
  return (
    <div style={styles.container}>
      {/* Right Side (Image) */}
      <div style={styles.rightSide}>
        <div style={styles.imageContainer}>
          <img
            src="/image/ai-ml-about.png"
            alt="AI Representation"
            style={styles.image}
          />
        </div>
      </div>

      {/* Left Side (Text Content) */}
      <div style={styles.leftSide}>
        <h2 style={styles.header}>The Power of AI/ML</h2>
        <p style={styles.paragraph}>
          AI and machine learning enable you to extract valuable insights from
          vast amounts of data, automate workflows, and optimize business
          processes. Our team specializes in building AI/ML models that are
          tailored to your unique requirements.
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Predictive Analytics for Smarter
            Decision-Making
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Automation of Repetitive and
            Complex Tasks
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Real-Time Data Processing and
            Model Deployment
          </li>
        </ul>
      </div>
    </div>
  );
};

// Responsive styles using JS
const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap", // allows stacking on small screens
    justifyContent: "center",
    alignItems: "center",
    padding: "2rem",
    backgroundColor: "#025261",
    color: "#fff",
  },
  leftSide: {
    flex: "1 1 400px", // grow, shrink, min-width
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  header: {
    fontSize: "clamp(1.5rem, 4vw, 2.5rem)", // scales with screen
    fontWeight: "bold",
    color: "white",
    marginBottom: "1rem",
  },
  paragraph: {
    fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)",
    margin: "1rem 0",
    textAlign: "justify",
    lineHeight: "1.6",
  },
  list: {
    listStyleType: "none",
    paddingLeft: 0,
  },
  listItem: {
    fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)",
    marginBottom: "0.7rem",
    display: "flex",
    alignItems: "center",
  },
  arrow: {
    marginRight: "0.6rem",
    color: "#4CAF50",
    fontSize: "1.2rem",
  },
  rightSide: {
    flex: "1 1 400px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "1rem",
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  image: {
    width: "100%",
    maxWidth: "450px",
    height: "auto",
    borderRadius: "8px",
  },
};

export default AIComponent;
